import axios from 'axios'
import router from '@/router'
import api from '@/api'
import { fromLocalTimeToUTC, fromUTCTimeToLocal } from '@/functions'
import { checkResponseNotFound } from '@/interceptorsHelpers'

const ebsTrainer = {
  state: {
    data: {
      id: '',
      name: '',
      lmsId: {
        id: '',
        domain: ''
      },
      contactEmail: '',
      contactPhone: '',
      email: '',
      subdomains: [],
      files: [],
      workingHours: [
        {
          weekday: 0,
          workFrom: '',
          workFromLocal: '',
          workTo: '',
          workToLocal: ''
        },
        {
          weekday: 1,
          workFrom: '',
          workFromLocal: '',
          workTo: '',
          workToLocal: ''
        },
        {
          weekday: 2,
          workFrom: '',
          workFromLocal: '',
          workTo: '',
          workToLocal: ''
        },
        {
          weekday: 3,
          workFrom: '',
          workFromLocal: '',
          workTo: '',
          workToLocal: ''
        },
        {
          weekday: 4,
          workFrom: '',
          workFromLocal: '',
          workTo: '',
          workToLocal: ''
        },
        {
          weekday: 5,
          workFrom: '',
          workFromLocal: '',
          workTo: '',
          workToLocal: ''
        },
        {
          weekday: 6,
          workFrom: '',
          workFromLocal: '',
          workTo: '',
          workToLocal: ''
        }
      ]
    },
    default: {}
  },
  getters: {
    getTrainer: state => {
      return state.data
    },
    //
    getTrainerId: state => {
      return state.data.id
    },
    getTrainerName: state => {
      return state.data.name
    },
    getTrainerImage: state => {
      return state.data.files
    },
    getTrainerEmail: state => {
      return state.data.email
    },
    getTrainerWorkingHours: state => {
      return state.data.workingHours
    },
    getTrainerUser: state => {
      return { lmsId: state.data.lmsId.id, name: state.data.name, email: state.data.email }
    }
  },
  mutations: {
    GET_TRAINER (state, payload) {
      for (let i = 0; i < payload.workingHours.length; i++) {
        const timeStart = fromUTCTimeToLocal(payload.workingHours[i].workFrom)
        const timeEnd = fromUTCTimeToLocal(payload.workingHours[i].workTo)
        payload.workingHours[i].workFromLocal = timeStart || undefined
        payload.workingHours[i].workToLocal = timeEnd || undefined
      }
      state.data = payload
      state.default = JSON.parse(JSON.stringify(payload))
    },
    //
    CLEAR_TRAINER (state) {
      state.data = {
        id: '',
        name: '',
        lmsId: {
          id: '',
          domain: ''
        },
        email: '',
        subdomains: [],
        files: [],
        workingHours: [
          {
            weekday: 0,
            workFrom: '',
            workTo: ''
          },
          {
            weekday: 1,
            workFrom: '',
            workTo: ''
          },
          {
            weekday: 2,
            workFrom: '',
            workTo: ''
          },
          {
            weekday: 3,
            workFrom: '',
            workTo: ''
          },
          {
            weekday: 4,
            workFrom: '',
            workTo: ''
          },
          {
            weekday: 5,
            workFrom: '',
            workTo: ''
          },
          {
            weekday: 6,
            workFrom: '',
            workTo: ''
          }
        ]
      }
      state.default = JSON.parse(JSON.stringify(state.data))
    },
    RESET_TRAINER (state) {
      state.data = JSON.parse(JSON.stringify(state.default))
    },
    //
    SET_TRAINER_NAME (state, payload) {
      state.data.name = payload
    },
    SET_TRAINER_EMAIL (state, payload) {
      state.data.email = payload
    },
    SET_TRAINER_IMAGE (state, payload) {
      const currentImages = JSON.parse(JSON.stringify(state.data.files))
      state.data.files = [...currentImages, ...payload]
    },
    SET_TRAINER_SUBDOMAINS (state, payload) {
      state.data.subdomains = payload
    },
    SET_TRAINER_WORKINGHOURS (state, payload) {
      if (state.data.workingHours[payload].workFrom) {
        state.data.workingHours[payload].workFrom = ''
        state.data.workingHours[payload].workFromLocal = ''
      } else {
        state.data.workingHours[payload].workFrom = fromLocalTimeToUTC('09:00')
        state.data.workingHours[payload].workFromLocal = '09:00'
      }
      if (state.data.workingHours[payload].workTo) {
        state.data.workingHours[payload].workTo = ''
        state.data.workingHours[payload].workToLocal = ''
      } else {
        state.data.workingHours[payload].workTo = fromLocalTimeToUTC('17:00')
        state.data.workingHours[payload].workToLocal = '17:00'
      }
    },
    SET_TRAINER_WORKINGHOURS_WORKFROMLOCAL (state, payload) {
      state.data.workingHours[payload.key].workFromLocal = payload.value
    },
    SET_TRAINER_WORKINGHOURS_WORKTOLOCAL (state, payload) {
      state.data.workingHours[payload.key].workToLocal = payload.value
    },
    SET_TRAINER_WORKINGHOURS_WORKFROM (state, payload) {
      const time = state.data.workingHours[payload.key].workFromLocal
      if (!(time)) return
      state.data.workingHours[payload.key].workFrom = fromLocalTimeToUTC(time)
    },
    SET_TRAINER_WORKINGHOURS_WORKTO (state, payload) {
      const time = state.data.workingHours[payload.key].workToLocal
      if (!(time)) return
      state.data.workingHours[payload.key].workTo = fromLocalTimeToUTC(time)
    },
    SET_TRAINER_USER (state, payload) {
      state.data.lmsId.id = payload.value.lmsId
      state.data.name = payload.value.name
      state.data.email = payload.value.email
    },
    SET_USER_DOMAIN (state, payload) {
      state.data.lmsId.domain = payload
    },
    //
    REMOVE_TRAINER_IMAGE (state, key) {
      state.data.files.splice(key, 1)
    }
  },
  actions: {
    getTrainer ({ commit }, id) {
      return new Promise((resolve, reject) => {
        commit('CLEAR_TRAINER')
        axios({
          method: 'get',
          url: `${api.classroom}/trainers/${id}`
        }).then(response => {
          commit('GET_TRAINER', response.data)
          resolve(response.data)
        }).catch(error => {
          checkResponseNotFound(error.response.status)
          reject(error)
        })
      })
    },
    //
    clearTrainer (context) {
      context.commit('CLEAR_TRAINER')
    },
    resetTrainer (context) {
      context.commit('RESET_TRAINER')
    },
    removeTrainer ({ commit, dispatch }, id) {
      axios.delete(
        `${api.classroom}/trainers/${id}`
      ).then(function (response) {
        dispatch('defaultNotificationToastsAdd', {
          title: 'Trainer remove',
          message: `Trainer has been successfully removed.`,
          status: 'success'
        })
        commit('CLEAR_TRAINER')
        commit('CLEAR_TRAINERS')
        commit('CLEAR_USER_CUSTOM')
        router.push({ name: 'ebs-trainer-list' })
      }).catch(function () {
        dispatch('defaultNotificationToastsAdd', {
          title: 'Trainer remove',
          message: `Trainer hasn't been removed.`,
          status: 'error'
        })
      })
    },
    updateTrainer ({ commit, state, dispatch }) {
      let trainerId = state.data.id
      axios({
        method: 'patch',
        url: `${api.classroom}/trainers`,
        data: state.data
      }).then(function () {
        dispatch('defaultNotificationToastsAdd', {
          title: 'Trainer update',
          message: `Trainer has been successfully updated.`,
          status: 'success'
        })
        commit('CLEAR_TRAINERS')
        commit('CLEAR_TRAINER')
        router.push({ name: 'ebs-trainer-show', params: { id: trainerId } })
      }).catch(function () {
        dispatch('defaultNotificationToastsAdd', {
          title: 'Trainer update',
          message: `Trainer hasn't been updated.`,
          status: 'error'
        })
      })
    },
    createTrainer ({ commit, getters, state, dispatch }) {
      commit('SET_USER_DOMAIN', getters.getAuthUserSecondStageTokenDataDomain)
      commit('SET_TRAINER_SUBDOMAINS', getters.getAuthUserSecondStageTokenDataSubdomains)
      //
      axios({
        method: 'post',
        url: `${api.classroom}/trainers`,
        data: state.data
      }).then(function (response) {
        dispatch('defaultNotificationToastsAdd', {
          title: 'Trainer create',
          message: `Trainer has been successfully created.`,
          status: 'success'
        })
        commit('CLEAR_TRAINERS')
        commit('CLEAR_TRAINER')
        commit('CLEAR_USER_CUSTOM')
        router.push({ name: 'ebs-trainer-show', params: { id: response.data.id } })
      }).catch(function () {
        dispatch('defaultNotificationToastsAdd', {
          title: 'Trainer create',
          message: `Trainer hasn't been created.`,
          status: 'error'
        })
      })
    },
    //
    setTrainerName (context, value) {
      context.commit('SET_TRAINER_NAME', value)
    },
    setTrainerEmail (context, value) {
      context.commit('SET_TRAINER_EMAIL', value)
    },
    setTrainerImage (context, data) {
      data = data.map(value => {
        return {
          fileId: value
        }
      })
      context.commit('SET_TRAINER_IMAGE', data)
    },
    setTrainerWorkingHours (context, value) {
      context.commit('SET_TRAINER_WORKINGHOURS', value)
    },
    setTrainerWorkingHoursWorkFrom (context, data) {
      context.commit('SET_TRAINER_WORKINGHOURS_WORKFROMLOCAL', { key: data.key, value: data.value })
      context.commit('SET_TRAINER_WORKINGHOURS_WORKFROM', { key: data.key, value: data.value })
    },
    setTrainerWorkingHoursWorkTo (context, data) {
      context.commit('SET_TRAINER_WORKINGHOURS_WORKTOLOCAL', { key: data.key, value: data.value })
      context.commit('SET_TRAINER_WORKINGHOURS_WORKTO', { key: data.key, value: data.value })
    },
    setTrainerUser (context, data) {
      context.commit('SET_TRAINER_USER', data)
    },
    //
    removeTrainerImage (context, key) {
      context.commit('REMOVE_TRAINER_IMAGE', key)
    }
  }
}

export default ebsTrainer
